import styled from "styled-components";

import Branding from "./Branding";

const LandingTitle = () => {
  return (
    <Content>
      <ContentHeader className="landing__content-item">
        <Branding />

        <h2>We track & simulate OOSI events</h2>
        {/* <p className="description">
          <span
            style={{
              fontWeight: "700"
            }}
          >
            MyOOSI
          </span>{" "}
          will allow you create your own OOSI with a few clicks.
          <br />
          This service will be available very soon. <br /> If you leave your
          contact information, we will invite you when it is ready. <br />
        </p> */}
      </ContentHeader>
      {/* <ContentBody className="landing__content-item"></ContentBody> */}
    </Content>
  );
};

export default LandingTitle;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5rem;
  align-items: center;
`;

const ContentHeader = styled.section`
  padding-left: 2.5rem;

  > h2 {
    font-size: 2.7rem;
    font-weight: 500;
    line-height: 1.3;
    white-space: nowrap;
    margin-bottom: 3rem;
  }

  > p.description {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.5;

    white-space: pre-wrap;
  }
`;

const TextMargin = styled.div`
  margin: 1rem 0;
  font-size: 1.3rem;
  font-weight: 600;
`;

const ContentBody = styled.section`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 1.5;

  white-space: pre-wrap;
`;

const FirstLetter = styled.span`
  font-size: 3.5rem;
  font-weight: 500;
  line-height: 1.3;
  /* white-space: pre-wrap; */
  /* color: #e7c11d; */

  margin-right: 0.3rem;
  /* background-color: #f9f9f9; */
  /* padding: 0.5rem; */
  /* border-radius: 0.5rem; */
  /* box-shadow: 0 0 1rem 0.5rem #f9f9f9; */
  /* transform: translateY(-0.2rem); */
  /* transition: all 0.5s;
  &:hover {
    transform: translateY(-0.5rem) scale(1.1);
  } */
`;
